export default [
  {"id":"next-choose-role","path":"choose-role","component":"ChooseRoleApp","guard":"none"},
  {"id":"next-family","path":"family","component":"FamilyApp","guard":"none"},
  {"id":"next-family-activity","path":"family/activity","component":"FamilyApp","guard":"none"},
  {"id":"next-family-insights","path":"family/insights","component":"FamilyApp","guard":"none"},
  {"id":"next-family-plan","path":"family/plan","component":"FamilyApp","guard":"none"},
  {"id":"next-family-connections","path":"family/connections","component":"FamilyApp","guard":"none"},
  {"id":"next-family-settings","path":"family/settings","component":"FamilyApp","guard":"none"},
  {"id":"next-family-habits","path":"family/habits","component":"FamilyApp","guard":"none"},
  {"id":"next-family-report","path":"family/reports/:reportKey","component":"FamilyApp","guard":"none"}
];
